import { StatusTypes } from '../../core/models/events-models';
import { Provider } from '../provider-abstract';
export class GatewayProvider extends Provider {
  constructor() {
    super(...arguments);
    this.eventMapping = {
      newMessage: this._newMessage,
      participantJoin: this._participantJoin,
      transferChat: this._transferChat,
      acknowledgement: this._acknowledgement,
      isTyping: this._isTyping,
      pong: this.signalPongReceived,
      endChat: this._endChat,
      error: this._error,
    };
  }
  onInitiateChat() {
    this.session.chatInstance.emitStatusChange(
      this.providerIdentifier,
      StatusTypes.CONNECTED,
    );
  }
  onReconnectChat() {
    this.session.chatInstance.emitStatusChange(
      this.providerIdentifier,
      StatusTypes.CONNECTED,
    );
  }
  sendMessageHandler(data, token) {
    this.send({
      event: 'newMessage',
      data: {
        access_token: token,
        messageText: data,
        messageId: this.session.chatInstance.getCurrentMessageId().toString(),
      },
    });
  }
  sendEventHandler(action, token) {
    this.send({
      event: 'newEvent',
      data: {
        access_token: token,
        eventName: action.name,
        parameters: action.parameters,
        messageId: this.session.chatInstance.getCurrentMessageId().toString(),
      },
    });
  }
  sendIsTypingHandler() {
    this.send({
      event: 'isTyping',
    });
  }
  sendPing() {
    this.send({
      event: 'ping',
    });
  }
  onChatClose() {
    if (!this.session.chatInstance.getTransferInProgress()) {
      this.send({
        event: 'endChat',
        data: undefined,
      });
    }
    this.session.chatInstance.emitParticipantLeave(
      this.providerIdentifier,
      this.participantInfo,
    );
  }
  onTransferResult(newProviderId, isAvailable) {
    if (!isAvailable) {
      this.session.chatInstance.transferCanceled();
    }
    this.send({
      event: 'transferInitiated',
      data: {
        newProviderId,
        isAvailable,
      },
    });
  }
  webSocketMessageHandler(json) {
    const msg = JSON.parse(json.data);
    const eventName = msg === null || msg === void 0 ? void 0 : msg.event;
    const eventHandler = this.eventMapping[eventName];
    if (!eventHandler) {
      this.session.chatInstance.emitError(
        'MESSAGE_RECEIVE_FAILURE',
        'Bad message! Unsupported action!!',
      );
      return;
    }
    eventHandler.bind(this)(msg.data);
  }
  send(body) {
    this.sendToWebSocket({
      event: body.event,
      data: body.data,
    });
  }
  _newMessage(data) {
    const msg = data;
    if (this.providerConfig.supportsUserMessageAcknowledgements) {
      this.send({
        event: 'acknowledgement',
        data: {
          messageId: msg.messageId,
          timestamp: new Date(),
        },
      });
    }
    this.session.chatInstance.emitNewMessage(
      this.providerIdentifier,
      this.participantInfo,
      msg.messages,
    );
  }
  _participantJoin(data) {
    this.participantInfo = data.participant;
    this.session.chatInstance.emitParticipantJoin(
      this.providerIdentifier,
      this.participantInfo,
    );
  }
  _acknowledgement(data) {
    this.messageAcknowledgementReceived(+data.messageId);
  }
  _isTyping() {
    this.session.chatInstance.emitIsTyping(this.participantInfo);
  }
  _transferChat(data) {
    this.session.chatInstance.emitTransferRequestProvider(data);
  }
  _endChat(data) {
    const end = data;
    if (end.error) {
      this.session.chatInstance.emitError(
        'PROVIDER_ERROR',
        end.reasonCode,
        true,
      );
    }
    this.closeChat();
    this.session.chatInstance.emitChatEnd('PROVIDER');
  }
  _error(data) {
    const error = data;
    this.session.chatInstance.emitError(
      error.errorCode,
      error.errorMessage,
      error.endChat,
    );
    if (error.endChat) {
      this.closeChat();
      this.session.chatInstance.emitChatEnd('ERROR');
    }
  }
}
//# sourceMappingURL=gateway-provider.js.map
